import React, { useReducer, useEffect, useContext } from "react";
import Medusa from "../services/api";
import { AccountContext } from "context/account";

export const defaultStoreContext = {
  store: {
    name: "UpStyled",
    metadata: {
      address: {},
      service: [],
      reviews: [],
      following: [],
      follower: [],
    },
    product_type_meta: [],
    gallery: [],
    tags: [],
  },
  tags: [],
  userCapability: [],
  maUserCapMap: {},
};

export const StoreContext = React.createContext(defaultStoreContext);

const reducer = (state, action) => {
  switch (action.type) {
    case "updateStore":
      return {
        ...state,
        store: {
          ...state.store,
          ...action.payload,
        },
      };
    case "updateTags":
      return {
        ...state,
        tags: [...action.payload],
      };
    case "updateUserCapability":
      const list = action.payload;
      const temp = {};
      const maList = list.filter((x) => x.type == "ma");
      for (let i = 0; i < maList.length; i++) {
        temp[maList[i]["value"]] = maList[i]["id"];
      }
      return {
        ...state,
        userCapability: [...list],
        maUserCapMap: temp,
      };
    default:
      return state;
  }
};

export const StoreProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, defaultStoreContext);
  const account = useContext(AccountContext);

  useEffect(() => {
    if (account.id) {
      const asyncCall = async () => {
        try {
          await retriveStore();
        } catch (err) {
          console.log(err);
        }
      };
      asyncCall();
    }
  }, [account.id]);
  const retriveStore = () => {
    return Medusa.store.retrieve().then(({ data }) => {
      dispatch({ type: "updateStore", payload: data.store });
      return data;
    });
  };

  const updateStore = (update) => {
    if (update["metadata"]) {
      update["metadata"] = {
        ...state.store.metadata,
        ...update["metadata"],
      };
    }
    return Medusa.store.update(update).then(({ data }) => {
      const store = data.store;
      if (!store["metadata"]) {
        store["metadata"] = {
          address: {},
          service: [],
          reviews: [],
          following: [],
          follower: [],
        };
      }
      dispatch({ type: "updateStore", payload: store });
      return data;
    });
  };

  const updateStoreMeta = (metadata) => {
    const store = {
      metadata: {
        ...state.store.metadata,
        ...metadata,
      },
    };
    return Medusa.store.update(store).then(({ data }) => {
      const store = data.store;
      if (!store["metadata"]) {
        store["metadata"] = {
          address: {},
          service: [],
          reviews: [],
          following: [],
          follower: [],
        };
      }
      dispatch({ type: "updateStore", payload: store });
      return data;
    });
  };

  // Store tags
  const listStoreTags = () => {
    return Medusa.storeTag.listStoreTags().then(({ data }) => {
      dispatch({ type: "updateTags", payload: data.product_type });
      return data;
    });
  };

  const addStoreTag = (tag) => {
    return Medusa.storeTag.addStoreTag(tag).then(async ({ data }) => {
      try {
        await listStoreTags();
      } catch (err) {
        console.log(err);
      }

      return data;
    });
  };

  const getStoreTag = (id) => {
    return Medusa.storeTag.addStoreTag(id).then(({ data }) => {
      return data;
    });
  };

  const deleteStoreTag = (id) => {
    return Medusa.storeTag.addStoreTag(id).then(async ({ data }) => {
      try {
        await listStoreTags();
      } catch (err) {
        console.log(err);
      }
      return data;
    });
  };

  const listUserCapability = () => {
    return Medusa.userCapability.listUserCapability().then(({ data }) => {
      dispatch({ type: "updateUserCapability", payload: data.user_capability });
      return data;
    });
  };

  const getUserCapability = () => {
    return Medusa.userCapability.getUserCapability().then(({ data }) => {
      dispatch({ type: "updateUserCapability", payload: data.user_capability });
      return data;
    });
  };

  return (
    <StoreContext.Provider
      value={{
        ...state,
        retriveStore,
        updateStore,
        updateStoreMeta,
        listStoreTags,
        addStoreTag,
        getStoreTag,
        deleteStoreTag,
        listUserCapability,
        getUserCapability,
      }}
    >
      {children}
    </StoreContext.Provider>
  );
};
